import {
	GlobalSearchRequest,
	GlobalSearchResponse
} from "@/Contracts/Others/GlobalSearch";
import { AxiosResponse } from "axios";
import axios from "axios";
import { getRequest } from "../BackendService";
import { includeChildEntities } from "@/Contracts";

const globalSearchUrl = "/v2/search";

export const getGlobalSearch = async (
	globalSearchRequest: GlobalSearchRequest
): Promise<GlobalSearchResponse> => {
	try {
		let queryParams = ``;
		if (globalSearchRequest.nextCursor) {
			queryParams = globalSearchRequest.nextCursor;
		} else {
			queryParams = `limit=${globalSearchRequest.limit}`;
			if (globalSearchRequest.includedEntities.length > 0) {
				queryParams = `${queryParams}${
					queryParams.length > 0 ? "&" : ""
				}included_entity_types=${encodeURIComponent(
					globalSearchRequest.includedEntities.join(",")
				)}`;
			}
			queryParams = `${queryParams}${
				queryParams.length > 0 ? "&" : ""
			}q=${encodeURIComponent(globalSearchRequest.keywords)}`;
			if (globalSearchRequest.useAtlasSearch !== undefined)
				queryParams = `${queryParams}${
					queryParams.length > 0 ? "&" : ""
				}use_atlas_search=${encodeURIComponent(
					globalSearchRequest.useAtlasSearch
				)}`;
			if (globalSearchRequest.includeChildEntities?.length) {
				queryParams +=
					"&" +
					includeChildEntities(
						globalSearchRequest.includeChildEntities
					);
			}
		}
		const response: AxiosResponse<GlobalSearchResponse> = await axios(
			getRequest(
				`${globalSearchUrl}${
					queryParams.length > 0 ? `?${queryParams}` : ""
				}`,
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
